module.exports = __webpack_public_path__ + "img/green-check.1e8984c9.svg";